import dayjs from "dayjs";

const advancedFormat = require('dayjs/plugin/advancedFormat')
const utc = require('dayjs/plugin/utc') // dependent on utc plugin
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(advancedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * 处理时间的显示时间
 * @param value 时间值
 * @param format 格式
 * @param timeDifference 和北京时间之间的时差，例：-1为+7时区
 */
function showTime(value, format, timeDifference) {
  if(!value) {
    return ''
  }
  format = format || 'YYYY-MM-DD HH:mm:ss'
  timeDifference = timeDifference === 0 ? 0 : (timeDifference || -1)
  return dayjs(value).add(timeDifference, 'hour').format(format)
}
/**
 * 处理时间的显示时间
 * @param value 时间值
 * @param format 格式
 * @param timeDifference 和北京时间之间的时差，例：-1为+7时区
 */
function sendTime(value, format, timeDifference) {
  if(!value) {
    return ''
  }
  format = format || 'YYYY-MM-DD HH:mm:ss'
  timeDifference = timeDifference === 0 ? 0 : (timeDifference || -1)
  return dayjs(value).subtract(timeDifference, 'hour').format(format)
}


export default {
  showTime,
  sendTime
}



// WEBPACK FOOTER //
// ./src/utils/time.js